<template>
    <div :key="componentKey">
        <ejs-progressbar v-if="hasValidValue" :id="progressbarId" type='Linear'
                         :trackThickness='trackThickness'
                         :progressThickness='progressThickness'
                         :value='dataField'
                         height='20'
                         width="200"
                         isGradient=true
                         :rangeColors=range
                         :labelStyle='labelStyle'
                         :showProgressValue='showProgressValue'
                         :animation='animation'> </ejs-progressbar>
        <span v-else style="padding-left:10px">N/A</span>
    </div>
</template>


<script>
    import Vue from "vue";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import {
        ProgressBarPlugin,
    } from "@syncfusion/ej2-vue-progressbar";

    Vue.use(ProgressBarPlugin);

    Vue.use(ButtonPlugin);
    export default {
        name: 'ColumnTemplate',
        data() {
            return {
                data: {},

                range: [
                    { start: 0, end: 20, color: "grey" },
                    { start: 20, end: 40, color: "darkGray" },
                    { start: 40, end: 60, color: "darkGrey" },
                    { start: 60, end: 80, color: "lightGrey" },
                    { start: 80, end: 100, color: "white" },
                ],
                trackThickness: 24,
                progressThickness: 24,
                animation: {
                    enable: true,
                    duration: 1000,
                    delay: 0,
                },
                labelStyle: {
                    color: "black",
                },
                showProgressValue: true,
            }
        },
        methods: {
        },
        computed: {
            rawValue() {
                let raw = this.data[this.data.column.field];

                if (typeof raw === "string") {
                    raw = raw.replace("%", "").trim();
                }

                return raw;
            },

            hasValidValue() {
                const num = Number(this.rawValue);
                return Number.isFinite(num);
            },
            dataField: function () {
                return parseInt(this.data[this.data.column.headerText]);
            },
            progressbarId: function () {
                return (this._uid + "_" + this.data.column.field); 
            },
            componentKey() {
                return this.data.column.field + "_" + this.data.index;
            }
        }
    }
</script>

<style scoped>
</style>